export default function getTypeUserDescription(type: string) {

    let description = '';

    switch (type) {
        case 'A':
            description = "Administrador";
            break;
        case 'M':
            description = "Membro";
            break;
        case 'I':
            description = "Membro Individual";
            break;
        case 'S':
            description = "Solicitante";
            break;
        case 'R':
            description = "Visão Restrita";
            break;
        case 'V':
            description = "Visualizador";
            break;
        default:
            description = '';
    }

    return description;
}